export const ROUTES = {
  BASE_URL: "/",
  SIGN_IN: "/signIn",
  SIGN_UP: "/signUp",
  HOME:"/home",
  WAITER_SCREEN:"/waiterSide"
};
